import { all, takeLatest, put, call } from 'redux-saga/effects';

import { fetchBankInfo, patchBankInfo } from '@coconut/services/apis/bank';

import { showAlertBanner } from '@coconut/services/redux/alertBanner';

import {
  FETCH_BANK_INFO,
  PATCH_BANK_INFO,
  fetchBankInfoSuccess,
  patchBankInfoSuccess,
  fetchBankInfoFailure,
  patchBankInfoFailure,
} from '@coconut/services/redux/bank';

import { PASSBOOK_PIC } from '@coconut/constants/bankField';
import { ALERT_SUCCESS_THEME } from '@coconut/constants/alertBannerThemes';
export function* fetchBankInfoFlow() {
  try {
    const bankInfo = yield call(fetchBankInfo);

    yield put(fetchBankInfoSuccess(bankInfo));
  } catch (error) {
    yield put(fetchBankInfoFailure(error));
  }
}
export function* patchBankInfoFlow(action) {
  const { bankInfoData } = action.payload;

  const bankFormData = new FormData();
  Object.entries(bankInfoData).forEach(([key, value]) => {
    if (key === PASSBOOK_PIC) return;
    bankFormData.append(key, value);
  });
  const { passbook_pic } = bankInfoData;
  if (!!passbook_pic.file) bankFormData.append(PASSBOOK_PIC, passbook_pic.file);

  try {
    const patchResult = yield call(patchBankInfo, bankFormData);
    yield put(
      showAlertBanner({
        message: 'coconut:qaOnWeb.bank.success',
        theme: ALERT_SUCCESS_THEME,
      })
    );
    yield put(patchBankInfoSuccess(patchResult));
  } catch (error) {
    yield put(patchBankInfoFailure(error));
  }
}

export default function* () {
  yield all([takeLatest(FETCH_BANK_INFO, fetchBankInfoFlow)]);
  yield all([takeLatest(PATCH_BANK_INFO, patchBankInfoFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/bank.js